function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.434 6.884L6.03 2.288A2.25 2.25 0 119.212 5.47L3.91 10.773a.75.75 0 11-1.06-1.06l5.303-5.304A.75.75 0 107.09 3.35L1.788 8.652a2.25 2.25 0 003.182 3.182l5.303-5.303A3.75 3.75 0 004.97 1.227L.373 5.823a.75.75 0 101.061 1.061z",
  fill: "#8F90A6"
});

function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAttachment;